export enum AllotmentStatus {
  bookable = 0,
  closed = 1,
  hidden = 2,
}
